import { Dimensions } from 'react-native';
import { BLUE_GREY_100, BLUE_GREY_200, BLUE_GREY_300, LILAC_300, LILAC_500, TRANSPARENT_GREY_1000 } from '../colors';
var modalConfig = {
  theme: 'light',
  initialVisible: false,
  swipeEnabled: true,
  headerTitle: '',
  subTitle: '',
  modalSize: 'md',
  showHeaderTitle: true,
  showSubTitle: true,
  showCross: false,
  enableFullView: false,
  maxHeight: Dimensions.get('window').height * 0.934,
  dragFromTopOnly: true,
  closeOnPressMask: true,
  keyboardAvoidingViewEnabled: false,
  minDistanceToCloseRatio: 0.2,
  animationDuration: 220,
  headerAlignment: 'center',
  isScrollView: false,
  forceDesktopModal: false,
  config: {
    backgroundColor: TRANSPARENT_GREY_1000,
    containerBackgroundColor: LILAC_300,
    notchBackgroundColor: LILAC_500,
    crossBackgroundColor: LILAC_500,
    crossIconProps: {
      width: 14,
      height: 14
    },
    backBtnIconProps: {
      width: 14,
      height: 14
    },
    backBtnBackgroundColor: LILAC_500
  }
};
var whiteModalConfig = Object.assign(Object.assign({}, modalConfig), {
  theme: 'light',
  config: Object.assign(Object.assign({}, modalConfig.config), {
    containerBackgroundColor: BLUE_GREY_100,
    notchBackgroundColor: BLUE_GREY_300,
    crossBackgroundColor: BLUE_GREY_200,
    backBtnBackgroundColor: BLUE_GREY_200
  })
});
export default {
  light: modalConfig,
  dark: modalConfig,
  white: whiteModalConfig
};